import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Back",
		children: /* @__PURE__ */ _jsx("path", {
			id: "ð¨ Color",
			d: "M8.75657 15.1646C8.98151 15.3789 9.33756 15.3702 9.55183 15.1453C9.76609 14.9203 9.75744 14.5643 9.53249 14.35L4.84393 9.88407L15.8945 9.88407C16.2052 9.88407 16.457 9.63223 16.457 9.32157C16.457 9.01091 16.2052 8.75907 15.8945 8.75907L4.84386 8.75907L9.53249 4.29304C9.75743 4.07878 9.76609 3.72273 9.55183 3.49778C9.33756 3.27284 8.98151 3.26418 8.75657 3.47844L3.19237 8.77847C3.06568 8.89915 2.99071 9.05308 2.96748 9.21311C2.96062 9.24821 2.95703 9.28447 2.95703 9.32157C2.95703 9.35875 2.96064 9.39508 2.96752 9.43024C2.9908 9.59017 3.06575 9.74399 3.19237 9.8646L8.75657 15.1646Z",
			fill: "#0161FE"
		})
	})
});
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
